/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-alert */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-cycle */
import React, { useEffect, useState, useRef } from 'react';

import { DialogUtility } from '@syncfusion/ej2-popups';
import {
  GridComponent,
  Inject,
  ColumnsDirective,
  ColumnDirective,
  Search,
  Page,
  Toolbar,
  Edit,
  Sort,
  Filter,
  ForeignKey,
  Group,
  LazyLoadGroup,
  ExcelExport,
} from '@syncfusion/ej2-react-grids';
import { HtmlEditor, Image, Link, QuickToolbar, RichTextEditorComponent } from '@syncfusion/ej2-react-richtexteditor';

import { useNavigate } from 'react-router-dom';
import { Query } from '@syncfusion/ej2-data';
// import { DialogUtility } from '@syncfusion/ej2-react-popups';
import { useStateContext } from '../contexts/ContextProvider';
import orgpng from '../data/organization.png';
import { templatesGrid } from '../data/dummy';
import { Header } from '../components';
// HTMLPreview
const Templates = () => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=templates');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);

  const { REACT_APP_API_ENDPOINT } = process.env;
  const preview = { text: 'Preview', tooltipText: 'Preview HTML Content', prefixIcon: 'e-web-layout', id: 'previewhtml' };
  const add = { text: 'Add', tooltipText: 'Add HTML Template', prefixIcon: 'e-plus', id: 'add' };
  const edit = { text: 'Edit', tooltipText: 'Edit HTML Template', prefixIcon: 'e-edit', id: 'edit' };
  const del = { text: 'Delete', tooltipText: 'Delete HTML Template', prefixIcon: 'e-delete-2', id: 'delete' };

  const toolbarOptions = [del, add, edit, preview, 'Search', 'ExcelExport'];
  const { activeMenu, zRenderMode, boss, isMobile } = useStateContext();
  const selectionSettings = { mode: 'Row', type: 'Single' };
  const valuerules = { required: true };
  let crudUpdate = false;
  let crudCreate = false;
  let crudDelete = false;

  const grid = useRef(null);
  const orgData = [];
  let myScreenSize = 'auto';
  const {
    screenSize,
    setScreenSize,
  } = useStateContext();
  const groupOptions = {
    enableLazyLoading: true,
    columns: ['organizationid'],
  };

  /*
  const toolbarSettings = {
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
      'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
      'LowerCase', 'UpperCase', '|',
      'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
      'Outdent', 'Indent', '|',
      'CreateLink', 'Image', '|', 'ClearFormat', 'Print',
      'SourceCode', 'FullScreen', '|', 'Undo', 'Redo'],
  };
  */
  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  if (activeMenu === false) {
    myScreenSize = 'auto';
  } else {
    const s = (screenSize - 450).toString();
    myScreenSize = `${s}px`;
  }
  const gridOrgHeader = () => (
    <div className="">
      <img
        className="w-10 h-10"
        src={orgpng}
        alt="organization"
      />
      <pre>Organization</pre>
    </div>
  );

  const [data, setData] = useState([]);
  const [showHtml, setHtml] = useState(false);
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  // const iframe = { enable: true };

  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/templates?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json()
        .catch((err) => {
          console.error('Error parsing JSON:', err);
          return null;
        });

      // set state when the data received
      setData(mydata);
      setLoading(false);
    };
    dataFetch();
  }, []);
  const rteObj = useRef(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleChange = (args) => {
    // The event argument 'args' contains the new value
    setContent(args.value);
  };
  const handleSaveButtonClick = () => {
    if (rteObj.current) {
      setContent(rteObj.current.value);
      data.templates[selectedRow].html = rteObj.current.value;
    } else {
      DialogUtility.alert('Templates Save editor error');
      return;
    }
    fetch(`${REACT_APP_API_ENDPOINT}/templates`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(data.templates[selectedRow]),
    })
      .then((response) => response.json())
      .then(() => {
        // The added/edited data will be saved in the Grid
        // The default edit operation is cancelled
      })
      .catch(() => {
        DialogUtility.alert('An error has occured during Update!');
      });

    setHtml(false);
  };
  const actionComplete = (args) => {
    /** Set initial Focus */
    if (args.requestType === 'beginEdit') {
      const result = orgData.find(({ id }) => id === args.rowData.organizationid);

      // eslint-disable-next-line prefer-destructuring
      const dialog = args.dialog;
      if (dialog) {
        dialog.width = '300px';
        dialog.header = `Template: ${result.value}`;
      }
    }
    if (args.requestType === 'save' && args.form && args.action === 'add') {
      if (args.data) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        orgData.forEach((element) => {
          if (element.id === args.data.organizationid) {
            args.data.organizationid = element.id;
            args.data.organization = element.value;
          }
        });
        fetch(`${REACT_APP_API_ENDPOINT}/templates`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (!responseJson || !responseJson._id || responseJson._id.length === 0) {
              DialogUtility.alert('Template add failed');
              args.cancel = true;
              return;
            }
            if (responseJson && responseJson._id) {
              data.templates[0]._id = responseJson._id;
            }
          })
          .catch(() => {
            DialogUtility.alert('An error has occured during Insert!');
          });
      }
    } else if (args.requestType === 'save' && args.form && args.action === 'edit') {
      // Here you can send the updated data to your server using AJAX call
      orgData.forEach((element) => {
        if (element.id === args.data.organizationid) {
          args.data.organizationid = element.id;
          args.data.organization = element.value;
        }
      });
      fetch(`${REACT_APP_API_ENDPOINT}/templates`, {
        method: 'UPDATE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
        body: JSON.stringify(args.data),
      })
        .then((response) => response.json())
        .then(() => {
          // The added/edited data will be saved in the Grid
          // The default edit operation is cancelled
          args.cancel = true;
        })
        .catch(() => {
          DialogUtility.alert('An error has occured during Update!');
        });
    } else if (args.requestType === 'delete') {
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/templates`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(args.data),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
          })
          .catch(() => {
            DialogUtility.alert('An error has occured during Delete!');
          });
      }
    }
  };
  /*
  let dialogInstance;
  function dialogClick(f, hdr, content) {
    const ok = null;
    dialogInstance = DialogUtility.confirm({
      title: hdr,
      content,
      okButton: ok,
      cancelButton: { text: 'Cancel', click: () => { dialogInstance.hide(); } },
      showCloseIcon: true,
      closeOnEscape: true,
      isModal: true,
      animationSettings: { effect: 'Zoom' },
    });
  }
*/
  const openPreviewWindow = (htmlContent) => {
    const width = 320;
    const height = 640;

    const newWindow = window.open('', '_blank', `width=${width}, height=${height}, top=200, left=400, toolbar=no`);
    if (newWindow) {
      newWindow.document.write(htmlContent);
      newWindow.document.title = 'Preview HTML Content';

      newWindow.document.close();
    } else {
      DialogUtility.alert('Pop-up blocked! Please enable pop-ups for this site.');
    }
  };

  const clickHandler = (args) => {
    if (!grid || !grid.current) {
      return;
    }
    const selectedRecords = grid.current.getSelectedRecords();
    if (grid && args.item.properties.text === 'Excel Export') {
      const properties = {
        fileName: `Templates${new Date().toISOString()}.xlsx`,
      };
      grid.excelExport(properties);
    } else if (grid && args.item.properties.text === 'Edit') {
      if (!selectedRecords || selectedRecords.length === 0) {
        DialogUtility.alert('Please select a Row');
      }
      grid.current.startEdit();
    } else if (grid && args.item.properties.text === 'Delete') {
      if (!selectedRecords || selectedRecords.length === 0) {
        DialogUtility.alert('Please select a Row');
      }
      args.cancel = true;
      grid.current.deleteRecord();
    } else if (grid && args.item.properties.text === 'Add') {
      grid.current.addRecord();
    } else if (grid && args.item.properties.text === 'Preview') {
      if (!selectedRecords || selectedRecords.length === 0) {
        DialogUtility.alert('Please select an Row');
      } else if (selectedRecords && selectedRecords.length === 1) {
        const { html } = selectedRecords[0]; // name
        /*
        let replacedHtmlString = html.replace(/%s/g, 'THE SERVER WILL add CONTENT HERE '); // 'g' flag for global replacement
        if (name === 'mgVitalTemplate') {
          const link = 'https://monaco.com';
          const body = 'Threshold exceeded for {associate.Name}';
          replacedHtmlString = html.replace(/%s/, 'Monaco'); // 'g' flag for global replacement
          replacedHtmlString = replacedHtmlString.replace(/%s/, 'Notification from Sensocore!'); // 'g' flag for global replacement
          replacedHtmlString = replacedHtmlString.replace(/%s/, `Please login to your account to view the alert.<br /><div style="background-color:white"><a href="${link}">Vital Alert for ${body}</a></div>`); // 'g' flag for global replacement
        } else if (name === 'mgStandardTemplate') {
          replacedHtmlString = html.replace(/%s/, 'Monaco'); // 'g' flag for global replacement
          replacedHtmlString = replacedHtmlString.replace(/%s/, 'Heat Stress Application Information request from {email} for Monaco!'); // 'g' flag for global replacement
        } else if (name === 'mgWelcomeTemplate') {
          const link = 'https://monaco.com';
          replacedHtmlString = html.replace(/%s/, 'Monaco'); // 'g' flag for global replacement
          replacedHtmlString = replacedHtmlString.replace(/%s/, 'Information from Monaco!');
          replacedHtmlString = replacedHtmlString.replace(/%s/, `Use the following link to ... {login, forgot, reset, invite} <br /> OR <br />You have received an {ASSOCIATE, MANAGER} invitation from Monaco! :<br /><a href="${link}"><font color="white">{Account}</font></a> <br /> OR <br />Use the following invitation code {_id} in the MonacoMobile App Associate <br /> See attached QR code <br />`); // 'g' flag for global replacement
        }
        */
        //
        // dialogClick('na', `Preview ${selectedRecords[0].name}`, `<div>${replacedHtmlString}</div>`);
        setSelectedRow(grid.current.selectedRowIndex);

        setContent(html); // replacedHtmlString
        // setContent(selectedRecords[0].html);
        setHtml(true);
        if (html.length === 0) {
          openPreviewWindow(html); // replacedHtmlString
        }
      }
    }
  };
  /*
  const handleBeforeSanitizeHtml = (e) => {
    // Implement your custom sanitization logic here
    e.selectors.tags.push('style'); // Example: deny <style> tags
    // e.cancel = true; // Optionally, cancel the default sanitization
  };
  */
  if (loading) {
    return <p>Loading... </p>;
  }
  if (data.role && data.role.alerts) {
    if (data.role.alerts.permissions.includes('Create')) {
      crudCreate = true;
    }
    if (data.role.alerts.permissions.includes('Update')) {
      crudUpdate = true;
    }
    if (data.role.alerts.permissions.includes('Delete')) {
      crudDelete = true;
    }
    if (!data.role.alerts.permissions.includes('Read')) {
      return <p>Not authorized...</p>;
    }
  }
  const editing = {
    allowEditing: crudUpdate,
    allowAdding: crudCreate,
    allowDeleting: crudDelete,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
    allowEditOnDblClick: false,
    mode: 'Normal',
  };
  if (data.organization) {
    data.organization.forEach((org) => {
      orgData.push({ id: org._id, value: org.title });
    });
  }
  const organizations = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: data.organization,
      fields: { value: '_id', text: 'title' },
      query: new Query(),
    },
  };
  return (
    <div className="m-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh">
      <Header category="Administration" title="Templates" />
      <div className="e-adaptive-demo e-bigger">
        <div className="e-mobile-layout">
          <div className="e-mobile-content">
            {!showHtml && (
            <GridComponent
              dataSource={data.templates}
              width={myScreenSize}
              id="gridtemplates"
              allowPaging
              allowSorting
              allowExcelExport
              pageSettings={{ pageSize: 20 }}
              editSettings={editing}
              toolbar={toolbarOptions}
              toolbarClick={clickHandler}
              actionComplete={actionComplete}
              selectionSettings={selectionSettings}
              allowTextWrap
              ref={grid}
              enableAdaptiveUI={isMobile}
              enableStickyHeader={!isMobile}
              rowRenderingMode={zRenderMode}
              enableAltRow
              allowGrouping
              groupSettings={groupOptions}
              enablePersistence
            >
              <ColumnsDirective>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                {templatesGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
                <ColumnDirective
                  field="organizationid"
                  headerText="Organization"
                  width="150"
                  textAlign="Left"
                  editType="dropdownedit"
                  headerTemplate={gridOrgHeader}
                  edit={organizations}
                  visible
                  foreignKeyField="_id"
                  foreignKeyValue="title"
                  validationRules={valuerules}
                  dataSource={organizations.params.dataSource}
                />
              </ColumnsDirective>
              <Inject services={[Search, Page, Toolbar, Edit, Sort, Filter, ForeignKey, Group, LazyLoadGroup, ExcelExport]} />
            </GridComponent>
            )}
            {boss && showHtml && (
            // eslint-disable-next-line jsx-a11y/control-has-associated-label
            <div>
              <button type="button" className="e-btn" onClick={handleSaveButtonClick}>Save&nbsp;
                <span id="md_save" className="e-btn-icon e-save e-icons" />
              </button>
              <button type="button" className="e-btn" onClick={() => { setHtml(false); }}>Cancel&nbsp;
                <span id="md_cancel" className="e-btn-icon e-undo e-icons" />
              </button>
            </div>
            )}
            {/*
            {showHtml && (
              <HTMLPreview rteValue={content} />
            )}
              */}
            {showHtml && (
              <RichTextEditorComponent
                ref={rteObj}
                locale="en-US"
                value={content}
                enterKey="DIV"
                change={handleChange}
              >
                <Inject services={[Toolbar, Image, Link, HtmlEditor, QuickToolbar]} />
              </RichTextEditorComponent>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Templates;
